<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <v-checkbox
          :disabled="toggling"
          :input-value="isProvider"
          class="ma-0"
          hide-details
          @mousedown.native="toggle"
        />
      </v-flex>
      <v-flex v-if="error" grow>
        <div class="body-1">
          <a class="body-2 clickable" href="https://outages.telstra.com">
            Telstra</a
          >
          <template>
            <span class="ml-3 orange--text text--lighten-3">
              {{ error }}
            </span>
          </template>
        </div>
      </v-flex>
      <v-flex v-else grow>
        <div class="body-1">
          <a class="body-2 clickable" href="https://outages.telstra.com">
            Telstra</a
          >
          <template v-if="outages.length === 0">
            <span class="ml-3"> {{ outages.length }} outage </span>
          </template>
          <template v-else-if="outages.length === 1">
            <span class="ml-3 red--text text--lighten-3"> 1 outage </span>
          </template>
          <template v-else>
            <span class="ml-3 red--text text--lighten-3">
              {{ outages.length }} outages
            </span>
          </template>
          <template v-if="massOutage">
            <span class="red--text text--lighten-3">
              and a mass outage in this state
            </span>
          </template>
          <span v-if="suburb">in {{ suburb }}</span>
        </div>
      </v-flex>
      <v-flex shrink>
        <v-btn
          v-if="expand === 0 && outages.length > 0"
          :disabled="error"
          class="ma-0"
          icon
          @click="expand = -1"
        >
          <v-icon>expand_less</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="outages.length === 0 || error"
          class="ma-0"
          icon
          @click="expand = 0"
        >
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-progress-linear
      v-if="loading"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate
    />
    <v-divider v-else />
    <v-layout>
      <v-expansion-panel v-if="outages.length > 0" :value="expand">
        <v-expansion-panel-content>
          <v-data-table :headers="headers" :items="outages" hide-actions>
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.end || "N/A" }}
              </td>
              <td>{{ props.item.technology }}</td>
              <td>{{ props.item.dst.toFixed(2) }} km</td>
              <td>{{ props.item.description }}</td>
            </template>
            <template slot="no-data" />
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "telstra",
  data() {
    return {
      error: null,
      expand: -1,
      headers: [
        {
          text: "Estimated rectification",
          value: "eta",
          width: "1%",
        },
        {
          text: "Techno",
          value: "technology",
          width: "1%",
        },
        {
          text: "Approx. dst",
          value: "dst",
          width: "1%",
        },
        {
          text: "Description",
          value: "description",
        },
      ],
      isProvider: false,
      loading: false,
      massOutage: false,
      outages: [],
      suburb: "",
      toggling: false,
    };
  },
  created() {
    this.loading = true;
    this.$http
      .get(`/api/sites/${this.$route.params.id}/outages/telstra`)
      .then((r) => {
        this.suburb = r.data.suburb;
        this.outages = Array.from(r.data.outages);
        if (r.data.majorOutages.length > 1) {
          this.massOutage = true;
        }
      })
      .catch((err) => {
        this.error = "Error";
        /**
         * Do not make the border red if the error is the expected
         * VM ouside Australia.
         */
        if (err.response.status !== 403) {
          this.$emit("error");
        }
      })
      .finally(() => (this.loading = false));

    this.refresh();
  },
  methods: {
    refresh() {
      this.toggling = true;
      return this.$http
        .get(`/api/sites/${this.$route.params.id}/providers/telstra`, {
          headers: { "Cache-Control": "no-cache" },
        })
        .then((r) => (this.isProvider = r.data))
        .catch(() => this.$emit("error"))
        .finally(() => (this.toggling = false));
    },
    toggle() {
      if (this.isProvider) {
        this.toggling = true;
        this.$http
          .delete(`/api/sites/${this.$route.params.id}/providers/telstra`)
          .then(() => this.refresh())
          .catch(() => this.$emit("error"))
          .finally(() => (this.toggling = false));
      } else {
        this.toggling = true;
        this.$http
          .put(`/api/sites/${this.$route.params.id}/providers/telstra`)
          .then(() => this.refresh())
          .catch(() => this.$emit("error"))
          .finally(() => (this.toggling = false));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Outages/Telstra.vue